/**
 * 是否是布尔类型
 *
 * @param {Object} value 测试的值
 * @return {Boolean}
 */
var isType = require('./is-type');

var isBoolean = function isBoolean(value) {
  return isType(value, 'Boolean');
};

module.exports = isBoolean;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/type/is-boolean.js
// module id = 60
// module chunks = 0 1 2